export const trimLink = (link: string = '', charLimit: number): string => {
  if (typeof link !== 'string' || link.length === 0) return '';
  return link.length < charLimit
    ? link
    : link.slice(0, charLimit).concat('...');
};

export const prettifyLink = (link: string = ''): string => {
  if (typeof link !== 'string' || link.length === 0) return '';
  return link.startsWith('http') ? link.split('//')[1] : link;
};

export const fixUrl = (link: string = ''): string => {
  if (typeof link !== 'string' || link.length === 0) return '';
  return link.startsWith('http') ? link : 'https://'.concat(link);
};
